import { ERRORS_MESSAGE } from "@lhd/constants";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Checkbox, Form, Input, Space } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { Dispatch, FC, SetStateAction, useEffect } from "react";
import { AiOutlineMinus } from "react-icons/ai";
import { IoMdAdd } from "react-icons/io";
import OptionAdd from "../commons/OptionAdd";

type PropsType = {
  form: FormInstance<AppPartType>;
  getFieldClassName?: (name: string) => string;
  isClicked?: boolean;
  blurFields?: Record<number, boolean>;
  setBlurFields?: Dispatch<SetStateAction<Record<number, boolean>>>;
};

const MultichoiceSetting: FC<PropsType> = ({
  form,
  getFieldClassName,
  isClicked,
  blurFields,
  setBlurFields,
}) => {
  const options = Form.useWatch(["item_config_data", "options"], form);
  useEffect(() => {
    if (Array.isArray(options) && Object.keys(options[0]).length === 0) {
      form.setFieldValue(
        ["item_config_data", "options"],
        [
          { text: "サンプル1", value: "サンプル1" },
          { text: "サンプル2", value: "サンプル2" },
          { text: "サンプル3", value: "サンプル3" },
          { text: "サンプル4", value: "サンプル4" },
        ],
      );
    }
  }, [options, form]);

  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item valuePropName="checked" name="is_required_field">
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <div style={{ marginBottom: "0.5rem" }}>項目と順番</div>
      <OptionAdd
        isClicked={isClicked}
        blurFields={blurFields}
        setBlurFields={setBlurFields}
      />
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default MultichoiceSetting;
